export const BOTTOM_DRAWER_KEY = 'qlBottomDrawer'
export const COOKIE_DATE_OFFSET = 30 * 24 * 60 * 60 * 1000; // 30 days